import { useMemo } from 'react';
import { FormConfig, FormField } from 'components/common/form/FormConfig';
import i18n from 'i18n';
import { isNil } from 'lodash';
import { OutdoorDurationSelects } from './OutdoorDurationSelects';

const defalutOptions = [
  {
    label: i18n.t('outdoorForm.labels.duration30'),
    value: 30
  },
  {
    label: i18n.t('outdoorForm.labels.duration0'),
    value: 0
  }
];

export const useOutdoorDurationFields = (
  as: 'select' | 'input' | 'label' | 'minuteSecond' = 'select',
  validateDuration?: (value: number) => string | undefined,
  options = defalutOptions,
  // 分／秒下拉的分上界由它換算而來；只有 'minuteSecond' 模式會用到。
  maxSeconds?: number
): FormField[] => {
  const fields = useMemo(() => {
    const builder = new FormConfig.FieldsBuilder();
    if (as === 'label') {
      builder.addFormikLabel({
        label: i18n.t('creativeSetupFlow.labels.outdoorDuration'),
        name: 'typeProperties.duration',
        formatter: (value) => {
          if (value === '' || isNil(value)) {
            return `0 ${i18n.t('common.units.seconds')}`;
          }
          return +value === 0
            ? i18n.t(`outdoorForm.labels.duration${+value}`)
            : `${value} ${i18n.t('common.units.seconds')}`;
        }
      });
    } else if (as === 'minuteSecond') {
      builder.addFormikCustom({
        label: i18n.t('creativeSetupFlow.labels.outdoorDuration'),
        name: 'typeProperties.duration',
        render: () => (
          <OutdoorDurationSelects
            name='typeProperties.duration'
            maxSeconds={maxSeconds}
            validate={validateDuration}
          />
        )
      });
    } else if (as === 'select') {
      builder.addFormikSelect({
        label: i18n.t('creativeSetupFlow.labels.outdoorDuration'),
        name: 'typeProperties.duration',
        simpleValue: true,
        options
      });
    } else {
      builder.addFormikInputGroup({
        label: i18n.t('creativeSetupFlow.labels.outdoorDuration'),
        name: 'typeProperties.duration',
        type: 'number',
        fieldContentWidth: 'auto',
        postText: i18n.t('common.units.seconds'),
        validate: validateDuration
      });
    }

    return builder.build();
  }, [as, options, validateDuration, maxSeconds]);

  return fields;
};
